import { createSelector } from '@ngrx/store'
import { selectCreditState } from '../credit.selectors'

const selectGseGroupState = createSelector(selectCreditState, (state) => state.gseGroup)

export const selectGseGroupFilters = createSelector(selectGseGroupState, (state) => state.filters)

export const selectCurrentGseGroup = createSelector(
  selectGseGroupState,
  (state) => state.currentGseStructureGroupEntity,
)

export const selectCurrentGseGroupMembers = createSelector(
  selectGseGroupState,
  (state) => state.currentGseStructureGroupMemberEntities,
)

export const isGseGroupDirty = createSelector(selectGseGroupState, (state) => state.isDirty)

export const isGseGroupSaving = createSelector(selectGseGroupState, (state) => state.isSaving)

export const selectRemovedMemberIds = createSelector(
  selectGseGroupState,
  (state) => state.removedMemberIds,
)
